import { InjectionToken } from '@angular/core';

export const PRIVATE_BASE_PATH = new InjectionToken<string>('PRIVATE_BASE_PATH');
